{
  "oldschool": {
    "bpm": 110,
    "swing": 50,
    "kit": {},
    "l": {
      "8": "x.....x...x.....",
      "C": "....X.......X...",
      "H": "x.x.x.x.x.x.x.x.",
      "B": "......x.......x."
    },
    "n": "808 kick plays the bass role. Straight electro feel, claps on 2 and 4, cowbell accents."
  },
  "golden": {
    "bpm": 100,
    "swing": 56,
    "kit": {
      "click": 0.4
    },
    "l": {
      "K": "x.x.......x..x..",
      "S": "....X..g.g..X..g",
      "H": "x.x.x.x.x.x.x.x."
    },
    "n": "Funk-break feel: syncopated kick, ghost snares around the backbeat."
  },
  "tribe": {
    "bpm": 92,
    "swing": 58,
    "kit": {
      "kdec": 0.22,
      "click": 0.2
    },
    "l": {
      "K": "x......x..x.....",
      "S": "....X.......X...",
      "H": "x.x.x.x.x.x.x.x."
    },
    "n": "Sparse and dry. Kicks leave space for the filtered bass between hits."
  },
  "premier": {
    "bpm": 90,
    "swing": 57,
    "kit": {
      "click": 0.6,
      "kdec": 0.28
    },
    "l": {
      "K": "x.....x...x..x..",
      "S": "....X.......X...",
      "H": "x.x.x.x.x.x.x.x."
    },
    "n": "Hard knocking kick, cracking snare on 2 and 4, steady hats."
  },
  "peterock": {
    "bpm": 94,
    "swing": 60,
    "kit": {
      "kdec": 0.32
    },
    "l": {
      "K": "x......x.x......",
      "S": "....X..g....X.g.",
      "H": "XgxgXgxgXgxgXgxg",
      "O": "..............x."
    },
    "n": "Busy swung 16th hats with accents, ghost snares, open hat into the next bar."
  },
  "wu": {
    "bpm": 90,
    "swing": 55,
    "human": true,
    "dusty": true,
    "kit": {
      "kdec": 0.3
    },
    "l": {
      "K": "x......x..x.....",
      "S": "....X.......X...",
      "H": "x.x.x.x.x.x.x.x."
    },
    "n": "Simple and loose. Humanize plus dusty filter for grit."
  },
  "qb": {
    "bpm": 90,
    "swing": 52,
    "kit": {
      "click": 0.5,
      "kdec": 0.24
    },
    "l": {
      "K": "x......x..x.....",
      "S": "....X.......X...",
      "H": "..x...x...x...x."
    },
    "n": "Tight hard drums, sparse offbeat hats. Let the loop be menacing."
  },
  "gfunk": {
    "bpm": 94,
    "swing": 55,
    "kit": {
      "kdec": 0.3
    },
    "l": {
      "K": "x.....x.x.......",
      "S": "....X.......X...",
      "C": "....X.......X...",
      "H": "x.x.x.x.x.x.x.x.",
      "O": "......x.......x.",
      "P": "....x.......x..."
    },
    "n": "Clap stacked on the snare, open hats, tambourine on the backbeat."
  },
  "south": {
    "bpm": 76,
    "swing": 52,
    "kit": {},
    "l": {
      "8": "x.....x...x.x...",
      "C": "....X.......X...",
      "H": "x.x.x.x.x.x.x.x.",
      "P": "gggggggggggggggg"
    },
    "n": "Long 808 booms, claps, shaker running 16ths."
  },
  "memphis": {
    "bpm": 136,
    "swing": 50,
    "dusty": true,
    "kit": {
      "drive": 0.4
    },
    "l": {
      "8": "x......x..x.....",
      "S": "........X.......",
      "H": "xxxxxxxxrxxxxxxr",
      "B": "x..x..x...x..x.."
    },
    "n": "Half-time feel at 136: snare on beat 3, rattling hats, cowbell riff."
  },
  "chipmunk": {
    "bpm": 90,
    "swing": 55,
    "kit": {
      "click": 0.5,
      "kdec": 0.34
    },
    "l": {
      "K": "x.....xx..x.....",
      "S": "....X.......X...",
      "C": "....X.......X...",
      "H": "x.x.x.x.x.x.x.x."
    },
    "n": "Big knocking kick, clap-snare layer on 2 and 4."
  },
  "dilla": {
    "bpm": 90,
    "swing": 60,
    "human": true,
    "push": true,
    "kit": {
      "kdec": 0.26
    },
    "l": {
      "K": "x.....x..x.x....",
      "S": "....X.......X...",
      "H": "x.x.x.x.x.x.x.x."
    },
    "n": "Humanize pushes the kick early and drags the snare late. That tension is the feel."
  },
  "madvillain": {
    "bpm": 88,
    "swing": 56,
    "human": true,
    "dusty": true,
    "kit": {
      "kdec": 0.25
    },
    "l": {
      "K": "x..x......x.....",
      "S": "....X.......X...",
      "H": "x.xx.x.xx.x.xx.x"
    },
    "n": "Dusty and slightly off. Imagine it chopped from a record."
  },
  "jazz": {
    "bpm": 80,
    "swing": 62,
    "dusty": true,
    "kit": {
      "kdec": 0.22,
      "click": 0
    },
    "l": {
      "K": "x.........x..x..",
      "R": "....X.......X...",
      "H": "x.x.x.x.x.x.x.x."
    },
    "n": "Soft kick, rimshot backbeat, lazy swing."
  },
  "griselda": {
    "bpm": 86,
    "swing": 54,
    "dusty": true,
    "kit": {
      "kdec": 0.25
    },
    "l": {
      "K": "x.........x.....",
      "R": "....x.......x..."
    },
    "n": "Barely there: the loop and the voice do the work."
  },
  "trap": {
    "bpm": 140,
    "swing": 50,
    "kit": {
      "drive": 0.5,
      "edec": 1.1
    },
    "l": {
      "8": "x......x..x.....",
      "K": "x......x..x.....",
      "C": "........X.......",
      "H": "x.x.x.x.x.r.x.t."
    },
    "n": "Half time: clap on beat 3, hat rolls, kick and 808 together."
  },
  "drill": {
    "bpm": 142,
    "swing": 50,
    "kit": {
      "drive": 0.4,
      "edec": 0.9
    },
    "l": {
      "8": "x.....x...x.....",
      "S": "........X..x....",
      "H": "x..x..x.x..x..x.",
      "R": "...x.......x...."
    },
    "n": "Syncopated snare after beat 3, hats with gaps. Real drill slides the 808 between notes."
  },
  "phonk": {
    "bpm": 130,
    "swing": 50,
    "kit": {
      "drive": 0.8
    },
    "l": {
      "8": "x......x..x.....",
      "S": "....X.......X...",
      "H": "xxxxxxxxxxxxxxxx",
      "B": "x.xx.x.xx.x.x.x."
    },
    "n": "Cowbell melody on top of a distorted 808."
  },
  "cloud": {
    "bpm": 140,
    "swing": 50,
    "dusty": true,
    "kit": {
      "edec": 1.2
    },
    "l": {
      "8": "x.........x.....",
      "K": "x.........x.....",
      "C": "........X.......",
      "H": "x...x...x...x..."
    },
    "n": "Slow, half-time, lots of space."
  },
  "rage": {
    "bpm": 160,
    "swing": 50,
    "kit": {
      "drive": 1,
      "edec": 0.7
    },
    "l": {
      "8": "x..x..x...x..x..",
      "K": "x..x..x...x..x..",
      "C": "........X.......",
      "H": "x.x.x.x.x.x.r.x."
    },
    "n": "Kick and 808 locked together, relentless."
  },
  "melodic": {
    "bpm": 145,
    "swing": 50,
    "kit": {
      "edec": 1
    },
    "l": {
      "8": "x......x..x.....",
      "K": "x......x..x.....",
      "C": "........X.......",
      "H": "x.x.x.x.x.x.x.x."
    },
    "n": "Clean half-time groove under a big vocal."
  }
}
